import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { pauseColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getPause } from "../../../../api/sim";

const COPY_KEYS = ["id", "batch_id", "iccid", "status", "last_updated"];

const PauseBatch = () => (
  <BatchDetail
    title="Pause"
    apiGet={__getPause}
    client={CLIENTS.ultra}
    columnsFactory={pauseColumns}
    copyKeys={COPY_KEYS}
    exportAction="pause"
    retryOperation="pause"
    showTerminate
    getRowPath={(row) => `/ultra/pause/${row.id}`}
  />
);

export default PauseBatch;
